import Axios from "axios";
// import moment from "moment";
// import { latLng } from "leaflet";
import ingredient from '@/assets/json/employee.json'

const state = () => ({
  wfh: [],
  all: [],
  unit_kerja: [],
  // json_data: [],
  info: {},
  code: null,
  message: null,
  status: null,
  loading: false,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
});

const mutations = {
  set_wfh(state, wfh){
    state.wfh = wfh
  },
  set_all(state, all){
    state.all = all
  },
  set_unit_kerja(state, unit_kerja){
    state.unit_kerja = unit_kerja
  },
  // set_json_data(state, json_data){
  //   state.json_data = json_data
  // },
  set_info(state, info){
    state.info = info
  },
  set_code(state, code){
    state.code = code
  },
  set_message(state, message){
    state.message = message
  },
  set_status(state, status){
    state.status = status
  },
  set_loading(state, loading){
    state.loading = loading
  }
};

const actions = {
  // get_jadwal_wfh_or_wfa_1({ commit, state }) {
  //   return new Promise((resolve, reject) => {
  //     commit("set_loading", true);

  //     let url = state.host+"/v2/persuratan/jadwalwfo/unit";
  //     const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
  //     Axios.get(url, { headers: headers })
  //       .then((response) => {
  //         const data_jadwal_wfh_wfo = response.data;

  //         let jadwal = [];

  //         for (let i = 0; i < data_jadwal_wfh_wfo.length; i++) {
  //           const element = data_jadwal_wfh_wfo[i];
  //           if (element.status == 1) {
  //             jadwal.push({"id": element.id, "nip": element.nip, "kodeUnit": element.kodeUnit, "nameUnit": element.nameUnit, "tanggal": element.tanggal, "status": element.status, "createdBy": element.createdBy, "createdDate": element.createdDate})
  //           }
  //         }

  //         commit("set_loading", false);
  //         commit("set_wfh", jadwal.sort((a, b) => a.nip - b.nip));
  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         if (error.response.status == 401) {
  //           localStorage.removeItem("token");
  //           delete Axios.defaults.headers.common["Authorization"];
  //           this.$router.push({ name: "home" });
  //         }
  //         commit('set_message', error.response.data.error_description)
  //         commit("set_loading", false);
  //         reject(error);
  //       });
  //   });
  // },
  post_jadwal_wfh_or_wfa: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let jadwal_wfh_or_wfa = { tanggal: data.tanggal, nip: data.nip };

      let url = state.host+"/v2/persuratan/jadwalwfo";

      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };

      Axios.post(url, jadwal_wfh_or_wfa, { headers: headers })
        .then((response) => {
          commit("set_loading", false);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  delete_jadwal_wfh_or_wfa: function({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/v2/persuratan/jadwalwfo/delete/"+data.id;

      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };

      Axios.post(url, "", { headers: headers })
        .then((response) => {
          commit("set_loading", false);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  get_all_jadwal_wfh_or_wfa({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/v2/persuratan/jadwalwfo/";
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_jadwal_wfh_wfo = response.data;
          const employee = ingredient.records;

          let jadwal = [];
          // let json = []

          for (let i = 0; i < data_jadwal_wfh_wfo.length; i++) {
            const element = data_jadwal_wfh_wfo[i];
            if (element.status == 1) {
              for (let j = 0; j < employee.length; j++) {
                const element_employee = employee[j];
                if (element.nip == element_employee.nip) {
                  jadwal.push({"id": element.id, "nip": element.nip, "kodeUnit": element.kodeUnit, "nameUnit": element.nameUnit, "tanggal": element.tanggal, "status": element.status, "createdBy": element.createdBy, "createdDate": element.createdDate, "nama": element_employee.nama, "unit_kerja": element_employee.unit_kerja, "username": element_employee.username, "bagian": element_employee.bagian, "jabatan": element_employee.jabatan, nickname: false})
                  // json.push({"nip": element.nip, "nama": element_employee.nama, "unit_kerja": element_employee.unit_kerja, "tanggal": element.tanggal})
                }
              }
            }
          }

          const filterByOneValues = (arr, key, value) => {
            return arr.filter(item => item[key] === value);
          };

          const filterByTwoValues = (arr, key1, value1, key2, value2) => {
            return arr.filter(item => item[key1] === value1 && item[key2] === value2);
          };

          const filteredArray = data.unit_kerja == null ? filterByOneValues(jadwal, 'tanggal', data.tanggal) : filterByTwoValues(jadwal, 'tanggal', data.tanggal, 'unit_kerja', data.unit_kerja);

          commit("set_loading", false);
          commit("set_all", filteredArray.sort((a, b) => a.nip - b.nip));
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  get_jadwal_wfh_or_wfa({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/v2/persuratan/jadwalwfo/unit";
      const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const data_jadwal_wfh_wfo = response.data;
          const employee = ingredient.records;

          let jadwal = [];

          for (let i = 0; i < data_jadwal_wfh_wfo.length; i++) {
            const element = data_jadwal_wfh_wfo[i];
            if (element.status == 1) {
              for (let j = 0; j < employee.length; j++) {
                const element_employee = employee[j];
                if (element.nip == element_employee.nip) {
                  jadwal.push({"id": element.id, "nip": element.nip, "kodeUnit": element.kodeUnit, "nameUnit": element.nameUnit, "tanggal": element.tanggal, "status": element.status, "createdBy": element.createdBy, "createdDate": element.createdDate, "nama": element_employee.nama, "unit_kerja": element_employee.unit_kerja, "username": element_employee.username, "bagian": element_employee.bagian, "jabatan": element_employee.jabatan})
                }
              }
            }
          }

          commit("set_loading", false);
          commit("set_wfh", jadwal.sort((a, b) => a.nip - b.nip));
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  get_unit_kerja({ commit }) {
    return new Promise(() => {
          const employee = ingredient.records;

          let unit_kerja = [];

          const removeDuplicates = (arr, key) => {
            const seen = new Set();
            return arr.filter(item => {
              const keyValue = item[key];
              if (seen.has(keyValue)) {
                return false;
              } else {
                seen.add(keyValue);
                return true;
              }
            });
          };
        
          const uniqueArray = removeDuplicates(employee, 'unit_kerja');

          for (let i = 0; i < uniqueArray.length; i++) {
            const element = uniqueArray[i];
            unit_kerja.push({"label": element.unit_kerja, "value": element.unit_kerja}) 
          }

          commit("set_loading", false);
          commit("set_unit_kerja", unit_kerja);
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};